/**
 * normalizeOutputDefaults
 *
 * Mappt Werte aus dem User-Settings-System (Settings.tsx, /api/v1/settings) auf das
 * Wertesystem, das gemini-direct tatsaechlich versteht (siehe
 * app/api/v2/gemini_helpers/image_processing.py + validation.py). Beide Systeme sind
 * historisch unabhaengig gewachsen und teilweise inkompatibel - siehe
 * GenerationOutputFormatSection.tsx.
 */

const PNG_QUALITY_MAP: Record<string, string> = {
  web_optimized: 'web',
};

// gemini-direct kennt kein 'avif' (nur png/jpeg/webp) - Fallback verhindert einen
// harten HTTP 400 bei jeder Generierung fuer Nutzer mit diesem Settings-Default.
const IMAGE_FORMAT_MAP: Record<string, string> = {
  avif: 'png',
};

export function normalizePngQuality(value: string | number | undefined): string {
  // WorkspaceConfig.defaults.png_quality is typed as number for historical reasons
  // (pre-dates the string-enum Settings system) - coerce defensively either way.
  if (value === undefined || value === null || value === '') return 'web';
  return PNG_QUALITY_MAP[String(value)] ?? String(value);
}

export function normalizeImageFormat(value: string | undefined): string {
  if (!value) return 'png';
  return IMAGE_FORMAT_MAP[value] ?? value;
}
